import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css'; // Your CSS file
import logo from '../Logo/logo-Photoroom.png';
import api from '../services/api';


const API_LOGIN_URL =  api.defaults.baseURL + '/auth/login';

// --- Icon Components (Unchanged) ---
const IconEmail = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>;
const IconLock = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>;
const IconSpinner = () => <svg className="spinner" viewBox="0 0 50 50"><circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle></svg>;



function Login({ setIsLoggedIn }) {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);

    const handleChange = (e) => {
        setError('');
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };
const togglePasswordVisibility = () => {
    console.log('Eye icon clicked! Current passwordShown:', passwordShown);
    setPasswordShown((prev) => {
        const newValue = !prev;
        console.log('passwordShown state will be set to:', newValue);
        return newValue;
    });
};
    // --- MODIFIED handleSubmit with professional error handling ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const response = await fetch(API_LOGIN_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: credentials.email, password: credentials.password }),
            });
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Login failed. Please check your credentials.');
            }

            // Store token and user data upon successful login
            localStorage.setItem('authToken', data.token);
            localStorage.setItem('user', JSON.stringify(data));
            setIsLoggedIn(true);
            
            // Redirect user based on their role from the API response
            const userRole = data.role;
            if (userRole === 'manager') {
                navigate('/Manager/ManagerDashboard');
            } else if (userRole === 'broker') {
                navigate('/broker/dashboard');
            } else if (userRole === 'admin') {
                navigate('/admin/manage-managers');
            } else {
                // A default redirect for any other roles or if role is not specified
                navigate('/dashboard');
            }

        } catch (err) {
            console.error('Login error:', err);

            if (err.message.includes('timed out') || err.message.includes('Failed to fetch')) {
                setError('Our server is experiencing a temporary issue. Please try again in a moment.');
            } else {
                setError(err.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* The rest of your JSX remains exactly the same. */}
            <div className="login-branding">
                <div className="branding-content">
                    <img src={logo} alt="Logo" style={{height:"100px", width:"80%"}}/>
                    <h3 className="branding-subtitle">Estates at White Oak - Luxury Living in Western Wake County, NC</h3>
                </div>
            </div>
            <div className="login-form-container">
                <div className="login-form-card">
                    <h2 className="login-title">Welcome Back</h2>
                    <p className="login-subtitle">Please enter your details to sign in.</p>
                    <form onSubmit={handleSubmit} noValidate>
                        {error && <div className="alert alert-error">{error}</div>}
                        <div className="input-group">
                            <label htmlFor="email">Email</label>
                            <div className="input-with-icon">
                                <IconEmail />
                                <input type="email" id="email" name="email" value={credentials.email} onChange={handleChange} placeholder="abc@gmail.com" required />
                            </div>
                        </div>
                        <div className="input-group">
                            <label htmlFor="password">Password</label>
                               <div className="input-with-icon">
                                <IconLock />
                                <input
                                    type={passwordShown ? 'text' : 'password'}
                                    id="password"
                                    name="password"
                                    value={credentials.password}
                                    onChange={handleChange}
                                    placeholder="Enter your password"
                                    required
                                />
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={togglePasswordVisibility}
                                    tabIndex={-1}
                                    aria-label={passwordShown ? "Hide password" : "Show password"}
                                >
                                <span style={{color: "#00A8A8",}}>{passwordShown ? "Hide" : "Show"}</span>
                                </button>
                                </div>
                        </div>
                        <button type="submit" className="btn-login" disabled={isLoading}>
                            {isLoading ? <IconSpinner /> : 'Sign In'}
                        </button>
                        <p className="login-footer">
                            Don't have an account? <Link to="/signup">Sign Up</Link>
                        </p>
                        <Link to="/forgot-password">Forgot Password?</Link>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;